const updates = [
  {
    date: "2026-07-30",
    time: "14:22",
    title: "某顶流男星前经纪人开直播爆料，称掌握更多未公开证据",
    tag: "最新",
    tagColor: "bg-primary-500",
  },
  {
    date: "2026-07-29",
    time: "21:05",
    title: "带货主播翻车事件持续发酵，品牌方集体发声明切割关系",
    tag: "跟进",
    tagColor: "bg-accent-500",
  },
  {
    date: "2026-07-29",
    time: "16:48",
    title: "爆料专区收到关键性匿名投稿，涉及某综艺节目财务造假",
    tag: "独家",
    tagColor: "bg-primary-500",
  },
  {
    date: "2026-07-28",
    time: "10:30",
    title: "税务部门回应明星税务问题：正在依法调查中，不予置评",
    tag: "跟进",
    tagColor: "bg-accent-500",
  },
  {
    date: "2026-07-27",
    time: "19:15",
    title: "MCN 机构内部人士匿名曝光行业黑幕，引发广泛讨论",
    tag: "热议",
    tagColor: "bg-accent-500",
  },
  {
    date: "2026-07-27",
    time: "08:00",
    title: "本周焦点专题「直播带货黑幕」更新第三期：售后维权困境",
    tag: "更新",
    tagColor: "bg-secondary-500",
  },
  {
    date: "2026-07-26",
    time: "22:40",
    title: "读者投稿精选：我在某顶流工作室做助理的那三年",
    tag: "精选",
    tagColor: "bg-secondary-500",
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          最新爆料
        </h2>
        <div className="w-16 h-1 bg-primary-500 mx-auto mb-10 rounded-full"></div>

        <div className="relative">
          <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-background-200"></div>

          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 pl-10 group cursor-pointer">
                <div className="absolute left-[13px] top-2 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100 group-hover:scale-125 transition-transform"></div>

                <div className="flex-shrink-0 text-right w-20">
                  <p className="text-foreground-500 text-xs">{item.date}</p>
                  <p className="text-foreground-600 text-xs">{item.time}</p>
                </div>

                <div className="flex-1 bg-background-50 rounded-lg px-4 py-3 border border-background-200/50 group-hover:border-primary-500/20 transition-colors">
                  <div className="flex items-start gap-3">
                    <span className={`flex-shrink-0 px-2 py-0.5 rounded text-xs font-semibold ${item.tagColor} text-background-50 whitespace-nowrap`}>
                      {item.tag}
                    </span>
                    <p className="text-foreground-300 text-sm group-hover:text-foreground-100 transition-colors leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}